<template>
	<v-snackbar
		v-model="snackbar"
		:color="type"
		top
		right
		:timeout="4000"
		rounded="xl"
		elevation="4"
	>
		<div class="d-flex align-center">
			<v-icon left small class="mr-2">
				{{
					type === "success" || type === "green"
						? "mdi-check-circle"
						: type === "error" || type === "red"
						? "mdi-alert-circle"
						: "mdi-information"
				}}
			</v-icon>
			<span class="snack-message">{{ message }}</span>
		</div>
		<template v-slot:action="{ attrs }">
			<v-btn icon x-small v-bind="attrs" @click="snackbar = false">
				<v-icon small>mdi-close</v-icon>
			</v-btn>
		</template>
	</v-snackbar>
</template>

<script>
export default {
	props: ["show", "message", "type"],
	data() {
		return { snackbar: false };
	},
	watch: {
		show(val) {
			this.snackbar = val;
		},
	},
};
</script>

<style scoped>
.snack-message {
	font-family: Montserrat, sans-serif;
	font-size: 0.82rem;
	font-weight: 600;
}
</style>
